import { render } from "./flagIcon.vue?vue&type=template&id=65a0538f&scoped=true"
import script from "./flagIcon.vue?vue&type=script&lang=js"
export * from "./flagIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a0538f"]])

export default __exports__